export default __webpack_public_path__ + "static/media/calendar-days.19643d06.svg";